import React, { useEffect } from 'react';
import { Route, Routes } from "react-router-dom";
import './styles/App.css';
import About from "./Pages/About";
import NotMatch from "./Pages/NotMatch";
import Footer from './components/Frame/Footer';
import Home from './Pages/Home';
import Products from './Pages/Products';
import Contact from './Pages/Contact';
import Privacy from './Pages/Privacy';
import DeleteSG from './Pages/DeleteSG';
import SGSupport from './Pages/SGSupport';
import EULA from './Pages/EULA';
import Header from './components/Frame/Header';
import Vision from './Pages/Vision';
import DeleteShekl from './Pages/DeleteShekl';

export var pageLoad: any = { instance: 1 };
function App() {
    return (
        <>
            <div className="App">
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/vision" element={<Vision />} />
                    <Route path="/products" element={<Products />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/deletesg" element={<DeleteSG />} />
                    <Route path="/deleteshekl" element={<DeleteShekl />} />
                    <Route path="/sgsupport" element={<SGSupport />} />
                    <Route path="/eula" element={<EULA />} />
                    <Route path="*" element={<NotMatch />} />
                </Routes>
            </div>
            <Header />
            <Footer />
        </>
    );
}

export default App;
